export default {
  name: 'bee-base-page'
};